import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home/Index.vue'

//关于我们
const Introduction = ()=>import('@/views/introduction/Index.vue')

//产品展示
const Products = ()=>import('@/views/products/Index.vue')


//工程案例
const Project =() =>import('@/views/project/Index.vue')


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Home
  },
  {
    //产品展示
    path:'/products',
    name: 'products',
    component:Products
  },
  {
    //产品详情
    path:'/details/:id',
    name: 'details',
    component: () => import('../views/products/details/Index.vue')
  },
  {
    //工程案例
    path:'/project',
    name: 'project',
    component:Project
  },
  {
    //关于我们
    path:'/introduction',
    name: 'introduction',
    component:Introduction,
  },
/*  {
    //关于我们 —— 公司发展历程
    path:'/introduction/process',
    name: 'process',
    component:Process,
  },
  {
    //关于我们 —— 荣誉资质
    path:'/introduction/honour',
    name: 'honour',
    component:Honour,
  },*/
  {//登录
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "about" */ '../views/login/Index.vue')
  }
]



const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 解决导航栏中的vue-router在重复点菜单报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router
